import React, { useState, useEffect } from "react";
import { Button, Icon, Modal, Grid, Segment, Popup, Responsive, Message, Label, Step, List, Image, Header, Table } from "semantic-ui-react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { displayGender } from "utils/displayGender";
import displayName from "utils/displayName";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import MainButton from "components/Buttons/MainButton";
import CustomPagination from "components/CustomPagination";
import moment from "moment-with-locales-es6";
import { MapInteractionCSS } from "react-map-interaction";
import debounce from "debounce-promise";
import { Checkbox } from "components/Form/SpecialButtons";
import { getFullName } from "utils/displayName";

moment.locale("fr");

const isMobile = () => {
	return window.innerWidth - Responsive.onlyMobile.maxWidth < 0;
};

const schemaValidation = Yup.object().shape({
	matricule: Yup.string(),
	doctorCode: Yup.string(),
});

const styles = {
	rowTitle: {
		marginTop: "12px",
		paddingTop: "12px",
		color: "#fff",
		backgroundColor: "teal",
		fontWeight: "bold",
		fontSize: "0.9em",
		alignItems: "center",
	},
	titleGrid: {
		paddingLeft: "0",
	},
	rowEven: {
		padding: 0,
		backgroundColor: "#fff",
	},
	rowOdd: {
		padding: 0,
		backgroundColor: "#00808021",
	},
	patientLabelGrid: {
		textAlign: "right",
		paddingRight: "10px",
		fontWeight: "bold",
		fontSize: "0.9em",
		width: "150px",
		padding: "3px 3px",
	},
	patientValueGrid: {
		textAlign: "left",
		fontSize: "0.9em",
		wordWrap: "break-word",
		padding: "3px 3px",
	},
	patientValueGridResult: {
		textAlign: "left",
		fontSize: "1.1em",
		fontWeight: "bold",
		wordWrap: "break-word",
		wordBreak: "break-all",
		borderBottom: "0px",
		borderTop: "0px",
		borderRight: "4px solid darkorange",
		borderLeft: "4px solid darkorange",
		padding: "3px 3px",
	},
	patientList: {
		backgroundColor: "#fff",
		width: "100%",
		position: "relative",
		padding: 10,
		display: "flex",
		borderRadius: "0",
		marginTop: "5px",
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		alignItems: "center",
	},
	patientListSelected: {
		backgroundColor: "#00808021",
		width: "100%",
		position: "relative",
		padding: 10,
		display: "flex",
		borderRadius: "0",
		marginTop: "5px",
		alignItems: "center",
		border: "4px solid teal",
		borderBottom: 0,
		boxShadow: "none",
	},
	patientListSelectedData: {
		backgroundColor: "#00808021",
		width: "100%",
		position: "relative",
		padding: 10,
		display: "flex",
		borderRadius: "0",
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		alignItems: "center",
		border: "4px solid teal",
		borderTop: 0,
	},
	doctorListSelected: {
		backgroundColor: "#00808021",
		width: "100%",
		position: "relative",
		padding: 10,
		display: "flex",
		borderRadius: "0",
		marginTop: "5px",
		alignItems: "center",
		border: "4px solid teal",
		boxShadow: "none",
	},

	sectionTitle: {
		fontSize: "14px",
		display: "flex",
		justifyContent: "center",
		padding: "5px 20px",
		color: "teal",
		borderRadius: "7px",
		border: "2px solid teal",
		fontWeight: "bolder",
	},
	roundHeaderContainer: {
		backgroundColor: "#43b39e",
		width: "100%",
		padding: 10,
		display: "flex",
		borderRadius: "4px 4px 0 0",
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		position: "relative",
	},
	columnFlex: {
		display: isMobile() ? "contents" : "flex",
		height: isMobile() ? "initial" : "100%",
		alignItems: "center",
	},
	titleInfo: {
		paddingRight: "10px",
		fontWeight: "bold",
		fontSize: "0.9em",
		width: "150px",
		padding: "3px 2px",
	},
};

const PatientMatchingModal = ({
	open,
	close,
	submit,
	used,
	data,
	mpi,
	dsp,
	mylab,
	mylabList,
	mylabPagination,
	page,
	searchByMatricule,
	selectPatientMyLab,
	deselectPatientMyLab,
	generalParameters,
	mylabListLarger,
	notifyMeForPreregister,
	refreshPreregisterFolder,
	cancelFolderHelp,
	isNurse,
	campaign,
	safeplace,
	eprescription,
	preregister,
	eprescriptionAgence,
	searchDoctors,
	submitEprescriptionAgence,
	isThemeHospital,
}) => {
	const [step, setStep] = useState(0);
	const [selectedDoctor, setSelectedDoctor] = useState(null);
	const [foundDoctor, setFoundDoctor] = useState(null);
	const [selectedDoctorList, setSelectedDoctorList] = useState([]);
	const isWaitingToTVSec =
		data && data.folder && data.folder.folderHelp && (data.folder.folderHelp.status === "NEW" || data.folder.folderHelp.status === "PENDING");
	const isAffectedToTVSec =
		data && data.folder && data.folder.folderHelp && (data.folder.folderHelp.status === "ASSIGNED" || data.folder.folderHelp.status === "SUPPORT");

	const isPatientMyLab =
		(data && data.folder && data.folder.patient && data.folder.patient.externalIds?.length !== 0) ||
		(!!eprescription && eprescription.patient && eprescription.patient.externalIds?.length !== 0);
	const patientData = (patient, type) => {
		if (patient)
			return (
				<Grid key={`grid-${patient.id}-${type}`}>
					<Grid.Row columns={2}>
						{patient.is_dead && patient.is_dead !== "N" && (
							<Grid.Column width={16} style={{ display: "flex", justifyContent: "center" }}>
								<span style={{ color: "red" }}>! personne décédée !</span>
							</Grid.Column>
						)}
						<Grid.Column style={styles.patientLabelGrid}> Nom de naissance: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>
							{" "}
							{(!!patient.birth_name && patient.birth_name.toUpperCase()) ||
								(type === "mylab" && !!patient.last_name && patient.last_name.toUpperCase()) ||
								"-"}
						</Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> Nom marital: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>
							{" "}
							{(type === "mylab" && !!patient.marital_name && patient.marital_name.toUpperCase()) ||
								(type !== "mylab" && patient.birth_name !== patient.last_name && !!patient.last_name && patient.last_name.toUpperCase()) ||
								"-"}
						</Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> Prénom: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>{patient.first_name || "-"}</Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> Genre: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>
							{(patient.gender === "male" || patient.gender === "m" || patient.gender === "M") && "Homme"}{" "}
							{patient.gender !== "male" && patient.gender !== "m" && patient.gender !== "M" && "Femme"}
						</Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> Date de naissance: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>{patient.birth_date ? moment(patient.birth_date).format("DD MMMM YYYY") : "-"}</Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> Téléphone: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>{patient.mobile_phone || patient.mobilephone || patient.phone} </Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> Email: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>{patient.email || "-"}</Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> N° pièce d'identité: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>{patient.identity_number || "-"}</Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> Matricule: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>{patient.matricule || patient.cns || "-"}</Grid.Column>
					</Grid.Row>
				</Grid>
			);
	};
	const doctorData = (doctor) => {
		if (doctor)
			return (
				<Grid key={`grid-${doctor.id}`}>
					<Grid.Row columns={2}>
						{doctor.title && <Grid.Column style={styles.patientLabelGrid}> Titre: </Grid.Column>}
						{doctor.title && <Grid.Column style={styles.patientValueGrid}> {doctor.title || "-"}</Grid.Column>}
						<Grid.Column style={styles.patientLabelGrid}> Nom: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}> {(doctor.last_name && doctor.last_name.toUpperCase()) || "-"}</Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> Prénom: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>{doctor.first_name || "-"}</Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> Code: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>{doctor.code || "-"}</Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> Téléphone: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>{doctor.phone || "-"}</Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> Fax: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>{doctor.fax || "-"}</Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> Email: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>{doctor.email || "-"}</Grid.Column>
						<Grid.Column style={styles.patientLabelGrid}> Adresse: </Grid.Column>
						<Grid.Column style={styles.patientValueGrid}>
							{doctor.address
								? `${doctor.address.street || ""}
								${doctor.address.postal_code || ""} ${doctor.address.city || ""} 
								${doctor.address.country !== "LUX" ? doctor.address.country || "" : ""}`
								: "-"}
						</Grid.Column>
						{doctor.speciality && <Grid.Column style={styles.patientLabelGrid}> Spécialité: </Grid.Column>}
						{doctor.speciality && <Grid.Column style={styles.patientValueGrid}> {doctor.speciality || "-"}</Grid.Column>}
					</Grid.Row>
				</Grid>
			);
	};

	const analysesData = (analyses) => {
		if (analyses)
			return (
				<>
					<Message warning={analyses.some((a) => a.bionext.length !== 1)} positive={!analyses.some((a) => a.bionext.length !== 1)}>
						{analyses.some((a) => a.bionext.length !== 1)
							? "La prescription contient des analyses qui n'ont pu être automatiquement liées à des analyses MyLab, le dossier doit passer au télésecrétariat."
							: "Toutes les analyses prescrites ont été correctement liées à des analyses connues de MyLab, vous pouvez commencer à prélever directement."}
					</Message>
					<Table basic="very" celled collapsing>
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell>Analyse prescrite</Table.HeaderCell>
								<Table.HeaderCell>Correspondance AES</Table.HeaderCell>
								<Table.HeaderCell>Correspondance BIONEXT</Table.HeaderCell>
								<Table.HeaderCell>Dispenses</Table.HeaderCell>
								<Table.HeaderCell>A dispenser</Table.HeaderCell>
							</Table.Row>
						</Table.Header>

						<Table.Body>
							{analyses.map((a) => (
								<Table.Row>
									<Table.Cell>
										{a.aes_catalog_name ? `${a.aes_catalog_name} - ` : ""}
										{a.code ? <b>{`${a.code} - `}</b> : ""}
										{a.name ?? ""} {a.quantity ? `(${a.quantity}x)` : ""}
									</Table.Cell>
									<Table.Cell>
										{a.aes_ref && `${a.aes_ref.aes_name}`}{" "}
										{a.aes_ref && a.aes_ref.aes_end_date && `[${moment(a.aes_ref.aes_end_date).format("DD/MM/YYYY")}]`}
									</Table.Cell>
									<Table.Cell negative={a.bionext && a.bionext.length === 0} warning={a.bionext && a.bionext.length > 1}>
										{a.bionext && a.bionext.length === 1 ? (
											a.bionext[0].code
										) : a.bionext && a.bionext.length === 0 ? (
											<>
												<Icon name="question circle outline" /> <span>Aucune correspondance trouvée</span>
											</>
										) : (
											<>
												<Icon name="code branch" rotated="clockwise" />
												<span> Plusieurs choix possibles</span>
											</>
										)}
									</Table.Cell>
									<Table.Cell>
										{a.dispenses.reduce((acc, disp) => acc + disp.done, 0)}/{a.quantity}
									</Table.Cell>
									<Table.Cell negative={a.dispenses.reduce((acc, disp) => acc + disp.done, 0) >= a.quantity}>
										{a.dispenses.reduce((acc, disp) => acc + disp.done, 0) >= a.quantity ? "non" : "oui"}
									</Table.Cell>
								</Table.Row>
							))}
						</Table.Body>
					</Table>
				</>
			);
	};

	const isSafeplace = !!safeplace;
	const isPreregister = !!preregister;
	const isCampaign = !!campaign;
	const isEPrescriptionMyLab = !!eprescription;
	const isEPrescriptionAgence = !!eprescriptionAgence;

	useEffect(() => {
		if (isEPrescriptionAgence) {
			searchDoctor(eprescriptionAgence.prescriber.code, true);
		}
	}, [isEPrescriptionAgence]);

	const doctorDataUpdated = (prescriber, selectedDoctor) => {
		return (
			<Grid divided="vertically">
				<Grid.Row columns={2} style={{ ...styles.rowTitle, textAlign: "center" }}>
					<Grid.Column>Médecin E-Prescription</Grid.Column>
					<Grid.Column>Association Médecin MyLab</Grid.Column>
				</Grid.Row>
				<Grid.Row columns={2}>
					<Grid.Column>{doctorData(prescriber)}</Grid.Column>
					<Grid.Column>{doctorData(selectedDoctor)}</Grid.Column>
				</Grid.Row>
			</Grid>
		);
	};

	const patientDataUpdated = (patientForm, patientMyLab, mpi, dsp, updates, values) => {
		let mylab = !!patientMyLab;
		if (patientForm)
			return (
				<Grid key={`grid-${patientForm.id}`}>
					<Grid.Row columns={mylab || mpi || dsp ? 4 : 3} style={styles.rowTitle}>
						<Grid.Column computer={3} tablet={3} style={styles.patientLabelGrid}>
							{" "}
						</Grid.Column>
						<Grid.Column computer={mylab || mpi || dsp ? 4 : 6} tablet={mylab || mpi || dsp ? 4 : 6} style={styles.titleGrid}>
							{" "}
							Formulaire Patient
						</Grid.Column>
						{mylab && (
							<Grid.Column computer={4} tablet={4} style={styles.titleGrid}>
								{" "}
								MyLab{" "}
							</Grid.Column>
						)}
						{!mylab && mpi && (
							<Grid.Column computer={4} tablet={4} style={styles.titleGrid}>
								{" "}
								Annuaire national des patients{" "}
							</Grid.Column>
						)}
						{!mylab && !mpi && dsp && (
							<Grid.Column computer={4} tablet={4} style={styles.titleGrid}>
								{" "}
								DSP{" "}
							</Grid.Column>
						)}
						<Grid.Column
							computer={mylab || mpi || dsp ? 5 : 7}
							tablet={mylab || mpi || dsp ? 5 : 7}
							style={{ ...styles.titleGrid, color: "darkorange", textTransform: "uppercase" }}
						>
							Données que vous conservez pour ce PATIENT <Icon name="arrow alternate circle down" size="large" color="orange" />{" "}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={mylab || mpi || dsp ? 4 : 3} style={styles.rowEven}>
						<Grid.Column computer={3} tablet={3} style={styles.patientLabelGrid}>
							{" "}
							Nom de naissance:{" "}
						</Grid.Column>
						<Grid.Column computer={mylab || mpi || dsp ? 4 : 6} style={styles.patientValueGrid}>
							{" "}
							{patientForm.birth_name || "-"}
						</Grid.Column>
						{mylab && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{" "}
								{(patientMyLab.birth_name && patientMyLab.birth_name.toUpperCase()) ||
									(patientMyLab.last_name && patientMyLab.last_name.toUpperCase()) ||
									"-"}
							</Grid.Column>
						)}
						{!mylab && mpi && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{" "}
								{mpi.birth_name || mpi.last_name || "-"}
							</Grid.Column>
						)}
						{!mylab && !mpi && dsp && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{" "}
								{dsp.birth_name || dsp.last_name || "-"}
							</Grid.Column>
						)}
						<Grid.Column
							computer={mylab || mpi || dsp ? 5 : 7}
							style={{ ...styles.patientValueGridResult, borderTop: "4px solid darkorange", borderBottom: 0 }}
						>
							{" "}
							{mylab
								? patientMyLab.birth_name || patientMyLab.last_name || "-"
								: updates.filter((f) => f.name === "birth_name").map((field) => radio(field.name, field.label, field.fields, values))}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={mylab || mpi || dsp ? 4 : 3} style={styles.rowOdd}>
						<Grid.Column computer={3} tablet={3} style={styles.patientLabelGrid}>
							{" "}
							Nom marital:{" "}
						</Grid.Column>
						<Grid.Column computer={mylab || mpi || dsp ? 4 : 6} style={styles.patientValueGrid}>
							{" "}
							{patientForm.last_name && patientForm.last_name !== patientForm.birth_name ? patientForm.last_name.toUpperCase() : "-"}
						</Grid.Column>
						{mylab && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{" "}
								{patientMyLab.marital_name || "-"}
							</Grid.Column>
						)}
						{!mylab && mpi && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{" "}
								{mpi.marital_name || "-"}
							</Grid.Column>
						)}
						{!mylab && !mpi && dsp && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{" "}
								{dsp.marital_name || "-"}
							</Grid.Column>
						)}
						<Grid.Column computer={mylab || mpi || dsp ? 5 : 7} style={styles.patientValueGridResult}>
							{" "}
							{mylab
								? patientMyLab.marital_name || "-"
								: updates.filter((f) => f.name === "married_name").map((field) => radio(field.name, field.label, field.fields, values)) || "-"}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={mylab || mpi || dsp ? 4 : 3} style={styles.rowEven}>
						<Grid.Column computer={3} tablet={3} style={styles.patientLabelGrid}>
							{" "}
							Prénom(s):{" "}
						</Grid.Column>
						<Grid.Column computer={mylab || mpi || dsp ? 4 : 6} style={styles.patientValueGrid}>
							{patientForm.first_name || "-"}
						</Grid.Column>
						{mylab && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{patientMyLab.first_name || "-"}
							</Grid.Column>
						)}
						{!mylab && mpi && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{mpi.first_name || "-"}
							</Grid.Column>
						)}
						{!mylab && !mpi && dsp && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{dsp.first_name || "-"}
							</Grid.Column>
						)}
						<Grid.Column computer={mylab || mpi || dsp ? 5 : 7} style={styles.patientValueGridResult}>
							{mylab
								? patientMyLab.first_name || "-"
								: updates.filter((f) => f.name === "first_name").map((field) => radio(field.name, field.label, field.fields, values))}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={mylab || mpi || dsp ? 4 : 3} style={styles.rowOdd}>
						<Grid.Column computer={3} tablet={3} style={styles.patientLabelGrid}>
							{" "}
							Genre:{" "}
						</Grid.Column>
						<Grid.Column computer={mylab || mpi || dsp ? 4 : 6} style={styles.patientValueGrid}>
							{(patientForm.gender === "male" || patientForm.gender === "m" || patientForm.gender === "M") && "Homme"}{" "}
							{patientForm.gender !== "male" && patientForm.gender !== "m" && patientForm.gender !== "M" && "Femme"}
						</Grid.Column>
						{mylab && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{(patientMyLab.gender === "male" || patientMyLab.gender === "m" || patientMyLab.gender === "M") && "Homme"}{" "}
								{patientMyLab.gender !== "male" && patientMyLab.gender !== "m" && patientMyLab.gender !== "M" && "Femme"}
							</Grid.Column>
						)}
						{!mylab && mpi && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{(mpi.gender === "male" || mpi.gender === "m" || mpi.gender === "M") && "Homme"}{" "}
								{((mpi.gender === "female" && mpi.gender === "f") || mpi.gender === "F") && "Femme"}
							</Grid.Column>
						)}
						{!mylab && !mpi && dsp && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{(dsp.gender === "male" || dsp.gender === "m" || dsp.gender === "M") && "Homme"}{" "}
								{dsp.gender !== "female" && dsp.gender !== "f" && dsp.gender !== "F" && "Femme"}
							</Grid.Column>
						)}
						<Grid.Column computer={mylab || mpi || dsp ? 5 : 7} style={styles.patientValueGridResult}>
							{mylab
								? ((patientMyLab.gender === "male" || patientMyLab.gender === "m" || patientMyLab.gender === "M") && "Homme") ||
								  (patientMyLab.gender !== "male" && patientMyLab.gender !== "m" && patientMyLab.gender !== "M" && "Femme")
								: updates.filter((f) => f.name === "gender").map((field) => radio(field.name, field.label, field.fields, values)) || "-"}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={mylab || mpi || dsp ? 4 : 3} style={styles.rowEven}>
						<Grid.Column computer={3} tablet={3} style={styles.patientLabelGrid}>
							{" "}
							Date de naissance:{" "}
						</Grid.Column>
						<Grid.Column computer={mylab || mpi || dsp ? 4 : 6} style={styles.patientValueGrid}>
							{patientForm.birth_date ? moment(patientForm.birth_date).format("DD MMMM YYYY") : "-"}
						</Grid.Column>
						{mylab && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{patientMyLab.birth_date ? moment(patientMyLab.birth_date).format("DD MMMM YYYY") : "-"}
							</Grid.Column>
						)}
						{!mylab && mpi && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{mpi.birth_date ? moment(mpi.birth_date).format("DD MMMM YYYY") : mpi.birthdate ? moment(mpi.birthdate).format("DD MMMM YYYY") : "-"}
							</Grid.Column>
						)}
						{!mylab && !mpi && dsp && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{dsp.birth_date ? moment(dsp.birth_date).format("DD MMMM YYYY") : dsp.birthdate ? moment(dsp.birthdate).format("DD MMMM YYYY") : "-"}
							</Grid.Column>
						)}
						<Grid.Column computer={mylab || mpi || dsp ? 5 : 7} style={styles.patientValueGridResult}>
							{mylab
								? patientMyLab.birth_date
									? moment(patientMyLab.birth_date).format("DD MMMM YYYY")
									: "-"
								: updates.filter((f) => f.name === "birth_date").map((field) => radio(field.name, field.label, field.fields, values)) || "-"}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={mylab || mpi || dsp ? 4 : 3} style={styles.rowOdd}>
						<Grid.Column computer={3} tablet={3} style={styles.patientLabelGrid}>
							{" "}
							Téléphone:{" "}
						</Grid.Column>
						<Grid.Column computer={mylab || mpi || dsp ? 4 : 6} style={styles.patientValueGrid}>
							{patientForm.mobile_phone || patientForm.mobilephone || "-"}{" "}
						</Grid.Column>
						{mylab && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{patientMyLab.mobile_phone || patientMyLab.mobilephone || "-"}{" "}
							</Grid.Column>
						)}
						{!mylab && mpi && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{mpi.mobile_phone || mpi.mobilephone || mpi.phone || "-"}{" "}
							</Grid.Column>
						)}
						{!mylab && !mpi && dsp && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{dsp.mobile_phone || dsp.mobilephone || dsp.phone || "-"}{" "}
							</Grid.Column>
						)}
						<Grid.Column computer={mylab || mpi || dsp ? 5 : 7} style={styles.patientValueGridResult}>
							{updates
								.filter((f) => f.name === "mobile_phone" || f.name === "phone")
								.map((field) => radio(field.name, field.label, field.fields, values)) || "-"}{" "}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={mylab || mpi || dsp ? 4 : 3} style={styles.rowEven}>
						<Grid.Column computer={3} tablet={3} style={styles.patientLabelGrid}>
							{" "}
							Email:{" "}
						</Grid.Column>
						<Grid.Column computer={mylab || mpi || dsp ? 4 : 6} style={styles.patientValueGrid}>
							{patientForm.email || "-"}
						</Grid.Column>
						{mylab && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{patientMyLab.email || "-"}{" "}
							</Grid.Column>
						)}
						{!mylab && mpi && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{mpi.email || "-"}{" "}
							</Grid.Column>
						)}
						{!mylab && !mpi && dsp && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{dsp.email || "-"}{" "}
							</Grid.Column>
						)}
						<Grid.Column computer={mylab || mpi || dsp ? 5 : 7} style={styles.patientValueGridResult}>
							{updates.filter((f) => f.name === "email").map((field) => radio(field.name, field.label, field.fields, values)) || "-"}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={mylab || mpi || dsp ? 4 : 3} style={styles.rowOdd}>
						<Grid.Column computer={3} tablet={3} style={styles.patientLabelGrid}>
							{" "}
							N° pièce d'identité:{" "}
						</Grid.Column>
						<Grid.Column computer={mylab || mpi || dsp ? 4 : 6} style={styles.patientValueGrid}>
							{patientForm.identity_number || "-"}
						</Grid.Column>
						{mylab && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{patientMyLab.identity_number || "-"}{" "}
							</Grid.Column>
						)}
						{!mylab && mpi && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{mpi.identity_number || "-"}{" "}
							</Grid.Column>
						)}
						{!mylab && !mpi && dsp && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{dsp.identity_number || "-"}{" "}
							</Grid.Column>
						)}
						<Grid.Column computer={mylab || mpi || dsp ? 5 : 7} style={styles.patientValueGridResult}>
							{updates.filter((f) => f.name === "identity_number").map((field) => radio(field.name, field.label, field.fields, values) || "-")}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={mylab || mpi || dsp ? 4 : 3} style={styles.rowEven}>
						<Grid.Column computer={3} tablet={3} style={styles.patientLabelGrid}>
							{" "}
							Matricule:{" "}
						</Grid.Column>
						<Grid.Column computer={mylab || mpi || dsp ? 4 : 6} style={styles.patientValueGrid}>
							{patientForm.matricule || patientForm.cns || "-"}
						</Grid.Column>
						{mylab && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{patientMyLab.matricule || patientMyLab.cns || "-"}{" "}
							</Grid.Column>
						)}
						{!mylab && mpi && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{mpi.matricule || mpi.cns || "-"}{" "}
							</Grid.Column>
						)}
						{!mylab && !mpi && dsp && (
							<Grid.Column computer={4} style={styles.patientValueGrid}>
								{dsp.matricule || dsp.cns || "-"}{" "}
							</Grid.Column>
						)}
						<Grid.Column computer={mylab || mpi || dsp ? 5 : 7} style={{ ...styles.patientValueGridResult, borderBottom: "4px solid darkorange" }}>
							{mylab
								? patientMyLab.matricule || patientMyLab.cns || "-"
								: updates.filter((f) => f.name === "cns").map((field) => radio(field.name, field.label, field.fields, values)) || "-"}
						</Grid.Column>
					</Grid.Row>
				</Grid>
			);
	};

	const defineFields = (patient, mylab, mpi, dsp) => {
		let result = [
			{
				name: "birth_name",
				label: "Nom de naissance",
				fields: [
					{ id: "newPatient", customlabel: patient.birth_name },
					{ id: "mylab", customlabel: mylab?.birth_name ?? mylab?.last_name },
					{ id: "mpi", customlabel: mpi?.birth_name },
					{ id: "dsp", customlabel: dsp?.birth_name },
				],
				isMyLab: false,
			},
			{
				name: "married_name",
				label: "Nom marital",
				fields: [
					{ id: "newPatient", customlabel: patient.birth_name !== patient.last_name ? patient.last_name : "" },
					{ id: "mylab", customlabel: mylab?.marital_name ?? mylab?.last_name },
					{ id: "mpi", customlabel: mpi?.marital_name },
					{ id: "dsp", customlabel: dsp?.last_name },
					{ id: "void", customlabel: "Ne pas renseigner" },
				],
				isMyLab: false,
			},
			{
				name: "first_name",
				label: "Prénom(s)",
				fields: [
					{ id: "newPatient", customlabel: patient.first_name },
					{ id: "mylab", customlabel: mylab?.first_name },
					{ id: "mpi", customlabel: mpi?.first_name },
					{ id: "dsp", customlabel: dsp?.first_name },
				],
				isMyLab: false,
			},
			{
				name: "gender",
				label: "Genre",
				fields: [
					{
						id: "newPatient",
						customlabel:
							data.patient.gender === "male" || data.patient.gender === "m"
								? "Homme"
								: data.patient.gender !== "male" && data.patient.gender !== "m"
								? "Femme"
								: "Autre",
					},
					{
						id: "mylab",
						customlabel: mylab
							? mylab?.gender === "male" || mylab?.gender === "m"
								? "Homme"
								: mylab?.gender !== "male" && mylab?.gender !== "m"
								? "Femme"
								: "Autre"
							: null,
					},
					{ id: "mpi", customlabel: mpi ? (mpi?.gender === "M" ? "Homme" : mpi?.gender === "F" ? "Femme" : "Autre") : null },
					{ id: "dsp", customlabel: dsp ? (dsp?.gender === "M" ? "Homme" : dsp?.gender === "F" ? "Femme" : "Autre") : null },
				],
				isMyLab: false,
			},
			{
				name: "birth_date",
				label: "Date de naissance",
				fields: [
					{ id: "newPatient", customlabel: moment(data.patient.birth_date).format("DD MMMM YYYY") },
					{ id: "mylab", customlabel: mylab ? moment(mylab.birth_date).format("DD MMMM YYYY") : null },
					{ id: "mpi", customlabel: mpi ? moment(mpi?.birth_date).format("DD MMMM YYYY") : null },
					{ id: "dsp", customlabel: dsp ? moment(dsp?.birth_date).format("DD MMMM YYYY") : null },
				],
				isMyLab: false,
			},
			{
				name: "mobile_phone",
				label: "Téléphone",
				fields: [
					{ id: "newPatient", customlabel: patient.mobile_phone },
					{ id: "mylab", customlabel: mylab?.mobile_phone },
					{ id: "mpi", customlabel: mpi?.mobile_phone || mpi?.phone },
				],
				isMyLab: true,
			},
			{
				name: "email",
				label: "Email",
				fields: [
					{ id: "newPatient", customlabel: patient.email },
					{ id: "mylab", customlabel: mylab?.email },
					{ id: "mpi", customlabel: mpi?.email },
				],
				isMyLab: true,
			},
			{
				name: "identity_number",
				label: "N° pièce d'identité",
				fields: [
					{ id: "newPatient", customlabel: patient.identity_number },
					{ id: "mylab", customlabel: mylab?.identification },
					{ id: "mpi", customlabel: mpi?.identity_number },
					//{id:'void', customlabel:'Ne pas renseigner'}
				],
				isMyLab: true,
			},
			{
				name: "cns",
				label: "Matricule",
				fields: [
					{ id: "newPatient", customlabel: patient.matricule || patient.cns },
					{ id: "mylab", customlabel: mylab?.cns },
					{ id: "mpi", customlabel: mpi?.cns },
				],
				isMyLab: false,
			},
		];
		return result;
	};

	const getModifiedFields = (patient, mylab, mpi, dsp, isMyLab) => {
		const result = defineFields(patient, mylab, mpi, dsp)
			.map((field) => {
				return {
					field: field.name,
					label: field.label,
					values: field.fields.filter(
						(f, index, arr) =>
							field.isMyLab === isMyLab &&
							f.customlabel !== undefined &&
							f.customlabel !== null &&
							f.id !== "mpi" &&
							f.id !== "dsp" &&
							field.id !== f.id &&
							arr.filter((f1, i) => f1.customlabel !== undefined && f1.customlabel !== f.customlabel && index > i).length > 0
					),
				};
			})
			.filter((r) => r.values.length > 0);
		return result;
	};

	const handleOpenFolderClick = () => {
		submit(data.folder.patient);
		closeModal();
	};
	const handleUsePatient = (values) => {
		let patientResult;
		if (mylab) {
			patientResult = { ...mylab, mylab_id: mylab.id };
			delete patientResult.id;
			patientResult = updatePatient(patientResult, "mylab", data.patient, mpi, dsp, mylab, values);
		} else {
			patientResult = data.patient;
			patientResult = updatePatient(patientResult, "newPatient", data.patient, mpi, dsp, mylab, values);
		}
		let analysesToDispense = null;
		if (eprescription && eprescription.items && eprescription.otherDispenses && values.onlyNotDispensed) {
			analysesToDispense = eprescription.items
				.map((i) => i)
				.filter(
					(ana) => !eprescription.otherDispenses.flatMap((d) => d.analyses.map((a) => a.properties.catalog_code)).includes(ana.analysis_reference)
				)
				.map((a) => a.analysis_reference);
		}
		isEPrescriptionAgence
			? submitEprescriptionAgence(patientResult, selectedDoctor, eprescriptionAgence, analysesToDispenseEPN())
			: submit(data.patientMyLabNurse ? data.patientMyLabNurse : patientResult, analysesToDispense);
		closeModal();
	};
	const handleCreatePatient = (values) => {
		let patientResult = data.patient;
		patientResult = updatePatient(patientResult, "newPatient", data.patient, mpi, dsp, mylab, values);
		isEPrescriptionAgence
			? submitEprescriptionAgence(patientResult, selectedDoctor, eprescriptionAgence, analysesToDispenseEPN())
			: submit(patientResult, values.onlyNotDispensed);
		closeModal();
	};

	const radio = (name, label, fields, values) => {
		let filter = fields.filter(
			(f, index, arr) => f.customlabel && f.customlabel !== "" && arr.filter((f1, i) => f1.customlabel === f.customlabel && index >= i).length === 1
		);
		if (filter.length > 1)
			return (
				<div key={`radio-${name}-${label}`}>
					<div style={{ display: "flex", flexDirection: "column", alignItems: "baseline" }}>
						{filter.map((f, index) => (
							<span key={`filter-${name}-${f.id}`} style={{ display: "flex", justifyContent: "flex-start", alignItems: "baseline" }}>
								<Field
									style={{ margin: "5px" }}
									type="radio"
									name={name}
									value={f.id}
									checked={Object.values(values)[Object.keys(values).indexOf(name)] === f.id}
								/>
								{f.customlabel}
							</span>
						))}
					</div>{" "}
				</div>
			);
		if (filter.length === 1)
			return (
				<div key={`radio-solo-${name}-${label}`}>
					<div style={{ display: "flex", alignItems: "baseline" }}>{filter[0].customlabel}</div>
				</div>
			);
	};
	const closeModal = () => {
		setFoundDoctor(null);
		setSelectedDoctorList([]);
		setSelectedDoctor(null);
		setStep(0);
		close();
	};

	const updateFieldMPI = (patient, type, field, mpi) => {
		let result = { ...patient };
		result[field] = mpi[field];
		// eval(`result.${field}= mpi[field];`);
		return result;
	};
	const updateFieldDSP = (patient, type, field, dsp) => {
		let result = { ...patient };
		result[field] = dsp[field];
		// eval("result." + field + "= dsp[field];");
		return result;
	};
	const updateFieldMylab = (patient, type, field, mylab) => {
		let result = { ...patient };
		if (field === "identity_number") {
			result.identification = mylab[field];
			// eval("result.identification = mylab[field];");
		} else {
			result[field] = mylab[field];
			// eval("result." + field + "= mylab[field];");
		}
		return result;
	};
	const updateFieldForm = (patient, type, field, data) => {
		let result = { ...patient };
		if (type === "mylab" && field === "mobile_phone") {
			result.mobilephone = data[field];
		} else if (type === "mylab" && field === "identity_number") {
			result.identification = data[field];
		} else {
			result[field] = data[field];
			// eval("result." + field + "= data[field];");
		}

		return result;
	};
	const updateFieldEmpty = (patient, type, field) => {
		let result = { ...patient };
		if (type === "mylab" && field === "mobile_phone") {
			result.mobile_phone = "";
		} else if (type === "mylab" && field === "identity_number") {
			result.identification = "";
		} else {
			result[field] = "";
			// eval("result." + field + "= '';");
		}
		return result;
	};

	const updatePatient = (patient, type, data, mpi, dsp, mylab, values) => {
		Object.entries(values).map((val) => {
			if (
				((type === "mylab" && val[1] !== "" && (val[0] === "email" || val[0] === "mobile_phone" || val[0] === "identity_number")) ||
					type !== "mylab") &&
				val[1] !== "" &&
				val[1] !== type
			) {
				switch (val[1]) {
					case "void":
						patient = updateFieldEmpty(patient, type, val[0]);
						break;
					case "mylab":
						patient = updateFieldMylab(patient, type, val[0], mylab);
						break;
					case "newPatient":
						patient = updateFieldForm(patient, type, val[0], data);
						break;
					case "mpi":
						patient = updateFieldMPI(patient, type, val[0], mpi);
						break;
					case "dsp":
						patient = updateFieldDSP(patient, type, val[0], dsp);
						break;
					default:
						break;
				}
			}
			return patient;
		});
		return patient;
	};

	const getFolderStatus = (status) => {
		switch (status) {
			case "NEW":
				return "En cours";
			case "PENDING":
				return "En cours";
			case "DONE":
				return "Terminé";
			case "HELP_NURSE":
				return "Télésecrétariat";
			case "CANCELED":
				return "Annulé";
			default:
				return "Statut indéterminé";
		}
	};
	const getWhat = () => {
		if (campaign) return `Campagne de prélèvements ${campaign.campaign?.name}`;
		if (eprescription) return "E-Prescription MyLab";
		if (preregister) return "Pré-inscription";
		if (safeplace) return "Safeplace";
		if (eprescriptionAgence) return "E-Prescription nationale";
		return "Autre demande";
	};

	const searchDoctor = (code, start = false) => {
		searchDoctors({ multiple_search: code }, 30, 0).then((res) => {
			setSelectedDoctorList(res.payload.data.results);
			if (start && res.payload.data.results?.length === 1) setFoundDoctor(res.payload.data.results[0]);
		});
	};

	const getTvSecInfo = () => {
		if (isWaitingToTVSec)
			return (
				<>
					<div>
						<Icon name="time" color="orange" /> File d'attente télésecrétariat{" "}
					</div>
					<>
						Dernière modification le {moment(data.folder.folderHelp.updated_at).format("DD MMM")} à{" "}
						{moment(data.folder.folderHelp.updated_at).format("HH:mm")}
						<br />
					</>
					<Segment>
						<Message icon>
							<Icon name="bell outline" />
							<Message.Content>
								<Message.Header>Ce dossier est actuellement en file d'attente pour le télésecrétariat.</Message.Header>
								Vous pouvez attendre qu'il soit traité par le secrétariat ou le récupérer et le compléter vous-même.{" "}
							</Message.Content>
						</Message>

						{isNurse && data.folder && data.folder.folderHelp && !data.folder.folderHelp.notified_to && (
							<Field customlabel="M'avertir quand le dossier sera prêt" component={Checkbox} label="toBeNotify" name="toBeNotify" id="toBeNotify" />
						)}
					</Segment>
				</>
			);
		if (isAffectedToTVSec)
			return (
				<>
					<div>
						<Icon name="time" color="orange" /> En cours de prise en charge par le télésecrétariat
					</div>
					<>
						Dernière modification le {moment(data.folder.folderHelp.updated_at).format("DD MMM")} à{" "}
						{moment(data.folder.folderHelp.updated_at).format("HH:mm")}
						<br />
					</>
					<Segment>
						<Message icon>
							<Icon name="bell outline" />
							<Message.Content>
								<Message.Header>Ce dossier est actuellement en traitement par le télésecrétariat.</Message.Header>
								Vous ne pouvez pas accéder au dossier en même temps qu'un.e secrétaire. <br />
							</Message.Content>
						</Message>

						{isNurse && (
							<Field customlabel="M'avertir quand le dossier sera prêt" component={Checkbox} label="toBeNotify" name="toBeNotify" id="toBeNotify" />
						)}
					</Segment>
				</>
			);
		else
			return (
				<>
					{data.folder && data.folder.folderHelp && data.folder.folderHelp.status === "CANCELED" && (
						<span>
							{`Demande de télésecrétariat annulée ${
								data.folder.folderHelp && data.folder.folderHelp.comments
									? `- motif: ${data.folder.folderHelp.comments.find((c) => c.cancellation)?.comment}`
									: ""
							}`}
						</span>
					)}
					{data.folder && data.folder.folderHelp && data.folder.folderHelp.status === "CANCELEDBYSEC" && (
						<span>
							<Icon name="warning" color="red" />
							{`Annulé par le secrétariat ${
								data.folder.folderHelp && data.folder.folderHelp.comments
									? `- motif d'annulation: ${data.folder.folderHelp.comments.find((c) => c.cancellation)?.comment}`
									: ""
							}`}
							{data.folder.folderHelp && data.folder.folderHelp.comments.filter((c) => c.manual && !c.cancellation).length > 0 && (
								<div>
									Autres commentaires laissés sur le dossier par le secrétariat :
									{data.folder.folderHelp &&
										data.folder.folderHelp.comments
											.filter((c) => c.manual && !c.cancellation)
											.map((c) => c.comment)
											.join(", ")}
								</div>
							)}
						</span>
					)}
					{data.folder && data.folder.folderHelp && (data.folder.folderHelp.status === "DONE" || data.folder.folderHelp.status === "REASSIGNED") && (
						<span>
							<Icon name="check" color="green" /> Saisi par le télésecrétariat (depuis le{" "}
							{moment(data.folder.folderHelp.updated_at).format("DD MMMM")} à {moment(data.folder.folderHelp.updated_at).format("HH:mm")})
						</span>
					)}
				</>
			);
	};
	const analysesToDispenseEPN = () => {
		if (eprescriptionAgence && eprescriptionAgence.analyses && eprescriptionAgence.analyses.length > 0) {
			return eprescriptionAgence.analyses.map((a) => {
				return { code: a.code, toDispense: a.dispenses.reduce((acc, disp) => acc + disp.done, 0) < a.quantity };
			});
		}
		return [];
	};
	const analysesToDispenseMyLab = (eprescription) => {
		return eprescription.items.filter(
			(ana) => !eprescription.otherDispenses.flatMap((d) => d.analyses.map((a) => a.properties.catalog_code)).includes(ana.analysis_reference)
		);
	};

	return (
		<Modal open={open} closeOnEscape closeOnDimmerClick onClose={closeModal} size="fullscreen">
			<Formik
				enableReinitialize
				initialValues={{
					matricule: data?.patient?.matricule || data?.patient?.cns || "",
					doctorCode: eprescriptionAgence?.prescriber?.code || "",
					mylabGroup: "newPatient",
					birth_name: "newPatient",
					married_name: "newPatient",
					first_name: "newPatient",
					gender: "newPatient",
					birth_date: "newPatient",
					mobile_phone: "newPatient",
					email: "newPatient",
					identity_number: "newPatient",
					cns: "newPatient",
					toBeNotify: true,
					useMylab: false,
					onlyNotDispensed: true,
					createAlreadyDispensed: false,
				}}
				validationSchema={schemaValidation}
			>
				{({ errors, values, setFieldValue }) => (
					<>
						<Modal.Content>
							{used && (
								<Message>
									<Message.Header>QR code déjà utilisé</Message.Header>
								</Message>
							)}
							{eprescriptionAgence && analysesToDispenseEPN().filter((a) => a.toDispense).length === 0 && (
								<>
									<Message warning icon="info" header={`Cette prescription a déjà été complètement dispensée.`} />
								</>
							)}
							{!used && (
								<Form
									onKeyUp={(e) => {
										e.preventDefault();
										if (step === 1 && (new RegExp("^\\d{8,}").test(values.matricule) || new RegExp("^[A-zÀ-ž]{3,}").test(values.matricule)))
											debounce(searchByMatricule(values.matricule, 1), 700);
										else if (step === 2 && new RegExp("^\\d{6}-\\d{2}").test(values.doctorCode)) debounce(searchDoctor(values.doctorCode), 700);
									}}
								>
									<Step.Group attached="top" style={{ width: "100%" }}>
										<Step active={step === 0}>
											<Icon name="wordpress forms" />
											<Step.Content>
												<Step.Title>Demande du patient</Step.Title>
												<Step.Description>{getWhat()}</Step.Description>
											</Step.Content>
										</Step>
										{(!data.folder || !data.folder.patient || data.folder.patient.externalIds.length === 0) && !isPatientMyLab && (
											<Step disabled={step < 1} active={step === 1}>
												<Icon name="user" />
												<Step.Content>
													<Step.Title>Association ou création d'un patient</Step.Title>
													<Step.Description>Recherche d'un patient</Step.Description>
												</Step.Content>
											</Step>
										)}
										{isEPrescriptionAgence && !foundDoctor && (
											<Step disabled={step < 2} active={step === 2}>
												<Icon name="doctor" />
												<Step.Content>
													<Step.Title>Association d'un médecin</Step.Title>
													<Step.Description>Recherche d'un médecin</Step.Description>
												</Step.Content>
											</Step>
										)}
										{!isPatientMyLab && (
											<Step disabled={step < 3} active={step === 3}>
												<Icon name="clipboard check" />
												<Step.Content>
													<Step.Title>Confirmation</Step.Title>
												</Step.Content>
											</Step>
										)}
									</Step.Group>
									{isPreregister && !data.folder && (
										<Segment placeholder>
											<Header icon>
												<Icon name="file excel outline" />
												Pas de dossier disponible
											</Header>
											<Message
												error
												icon="warning"
												header={`Une erreur s'est produite lors de cette pré-inscription.`}
												content={`Veuillez créer manuellement un nouveau dossier pour ce patient.`}
											/>
										</Segment>
									)}
									{isPreregister && preregister.deleted && preregister.deletedDate && (
										<Segment placeholder>
											<Header icon>
												<Icon name="file excel outline" />
												Demande de pré-inscription supprimée le {moment(preregister.deletedDate).format("DD/MM/YYYY à HH:mm")}
											</Header>
											<Message
												error
												icon="warning"
												header={`Cette pré-inscription a été annulée automatiquement après un trop long délai d'attente de la venue du patient.`}
												content={`Veuillez créer manuellement un nouveau dossier pour ce patient.`}
											/>
										</Segment>
									)}
									{campaign && data.folder && !data.folder.is_temp && (
										<Segment placeholder>
											<Header icon>
												<Icon name="file alternate outline" />
												Patient pour une campagne de prélèvements
											</Header>
											{data.folder.labAppointment && (
												<Message
													icon="info"
													header={`Dossier ${data.folder.code} - ${getFullName(data.folder.patient)}`}
													content={`Statut : ${getFolderStatus(data.folder.status)}) - ${data.folder.labAppointment.center.name}, le ${moment(
														data.folder.labAppointment._date + "T" + data.folder.labAppointment._time
													).format("DD/MM/YYYY à HH:mm")}`}
												/>
											)}
											{!data.folder.labAppointment && (
												<Message
													icon="cancel"
													header={`Dossier ${data.folder.code} `}
													content={`Non pris en charge dans un centre (Statut : ${getFolderStatus(data.folder.status)})`}
												/>
											)}
										</Segment>
									)}
									{isPreregister && data.folder && !data.folder.is_temp && !preregister.deleted && (
										<Segment placeholder>
											<Header icon>
												<Icon name="file excel outline" />
												Pré-inscription déjà traitée.
											</Header>
											{data.folder.labAppointment && (
												<Message
													icon="info"
													header={`Dossier ${data.folder.code} `}
													content={`${data.folder.labAppointment?.center?.name ?? "Centre non défini"}, le ${data.folder.labAppointment._date} à ${
														data.folder.labAppointment._time
													} (Statut : ${getFolderStatus(data.folder.status)})`}
												/>
											)}
											{!data.folder.labAppointment && (
												<Message
													icon="cancel"
													header={`Dossier ${data.folder.code} `}
													content={`Non pris en charge dans un centre (Statut : ${getFolderStatus(data.folder.status)})`}
												/>
											)}
										</Segment>
									)}
									{(isSafeplace ||
										isEPrescriptionMyLab ||
										isEPrescriptionAgence ||
										(isCampaign && data.folder.is_temp) ||
										(preregister && !preregister.deleted && data.folder && data.folder.is_temp)) && (
										<Segment attached>
											{step === 0 && (
												<>
													<Segment.Group
														horizontal={isMobile() ? false : true}
														raised
														piled
														style={{ justifyContent: "center", fontSize: "1.2em", alignItems: "flex-start", alignContent: "center" }}
													>
														{/* <Segment.Group style={{boxShadow:'none', border:'none'}}> */}
														<Segment basic>
															<div style={styles.titleInfo}>
																<Icon name="search" />
																Type de demande
															</div>
															{isCampaign && <div>Campagne de prélèvement</div>}
															{safeplace && safeplace.analysis && <div>{safeplace.analysis.code}</div>}
															{preregister && `Pré-inscription ${preregister.is_at_center ? "en centre" : "hors centre"}`}
															{eprescription && <div>{`E-Prescription ${eprescription.repetition !== 0 ? "renouvelable" : ""}`}</div>}
															{eprescriptionAgence && <div>{`E-Prescription nationale`}</div>}
															{eprescription && (
																<div>{`Valable du ${moment(eprescription.date).format("DD/MM/YYYY")} au ${moment(eprescription.validity_date).format(
																	"DD/MM/YYYY"
																)}`}</div>
															)}
															{eprescriptionAgence && (
																<div>{`Valable du ${moment(eprescriptionAgence.valid_from).format("DD/MM/YYYY")} au ${moment(
																	eprescriptionAgence.valid_to
																).format("DD/MM/YYYY")} `}</div>
															)}

															{data.folder && data.folder.folderHelp && (
																<div>
																	Demande reçue le {moment(data.folder.folderHelp.created_at).format("DD MMMM")} à{" "}
																	{moment(data.folder.folderHelp.created_at).format("HH:mm")}
																</div>
															)}
														</Segment>
														{data.patient && (
															<Segment basic>
																<div style={{ display: "flex", justifyContent: "space-between", flexDirection: isMobile() ? "column" : "row" }}>
																	<div>
																		<div style={styles.titleInfo}>
																			<Icon name="user" />
																			Patient
																		</div>
																		<span>{data.folder?.patient ? displayName(data.folder.patient) : displayName(data.patient)}</span>
																		<br />
																		{!isPatientMyLab && (
																			<div>
																				<Icon name="warning" color="red" />A associer ou à créer
																			</div>
																		)}
																		{isPatientMyLab && (
																			<div>
																				<Icon name="check" color="green" />
																				Connu dans MyLab
																			</div>
																		)}
																	</div>
																	{/* {isPatientMyLab && isThemeHospital && (
																		<div>
																			<Popup
																				content="Scannez l’identifiant unique du patient (bracelet, carte, …)."
																				position="top center"
																				trigger={
																					<div style={{ display: "flex" }}>
																						Identito-vigilance{" "}
																						{barcodePatient === "333" ? <Icon name="check" color="green" /> : <Icon name="x" color="red" />}
																					</div>
																				}
																			/>
																			<div>
																				<BarcodeButton
																					barcode={barcodePatient}
																					onClick={() => setBarcodeIsSelected(true)}
																					disabled={false}
																					isSelected={barcodeIsSelected}
																					submitBarCode={(value) => setBarcodePatient(value)}
																					cancelSelect={() => setBarcodeIsSelected(false)}
																					select={() => setBarcodeIsSelected(true)}
																				/>
																			</div>
																		</div>
																	)} */}
																</div>
															</Segment>
														)}
														{/* <Segment  basic>
												<div style={{paddingRight: '10px',fontWeight: 'bold',fontSize: '0.9em',	width: '150px',	padding:'3px 3px'}}>Ordonnance(s)</div>
												<div>{data.result && data.result.files && data.result.files.length > 0 ? <OrdonnancesFilesDisplay files={data.result.files} />  : "pas d'ordonnance"} </div>
												</Segment> */}
														<Segment basic>
															<div style={styles.titleInfo}>
																<Icon name="clipboard outline" /> Prise en charge
															</div>
															{campaign &&
																campaign.campaign &&
																campaign.campaign.billing_company &&
																`Société ${campaign.campaign.billing_company.name}`}
															{safeplace && safeplace.analysis && `${safeplace.analysis.price}€ payés en ligne.`}
															{safeplace && safeplace.voucher && ` Payé à l'aide d'un voucher (${safeplace.voucher})`}
															{eprescriptionAgence && eprescriptionAgence.prescriber && eprescriptionAgence.prescriber.code && foundDoctor && (
																<>
																	{`Ordonnance prescrite par ${eprescriptionAgence.prescriber?.last_name?.toUpperCase()} ${
																		eprescriptionAgence.prescriber.first_name
																	}`}
																	<div>
																		<Icon name="check" color="green" />
																		<span>{`Médecin associé automatiquement à ${foundDoctor.title} ${foundDoctor.last_name?.toUpperCase()} ${
																			foundDoctor.first_name
																		}`}</span>
																	</div>
																</>
															)}
															{eprescriptionAgence &&
																eprescriptionAgence.prescriber &&
																eprescriptionAgence.prescriber.code &&
																!foundDoctor &&
																selectedDoctorList.length > 1 && (
																	<>
																		{`Ordonnance prescrite par ${eprescriptionAgence.prescriber.last_name?.toUpperCase()} ${
																			eprescriptionAgence.prescriber.first_name
																		}`}
																		<div>
																			<Icon name="warning" color="red" />
																			Médecin à associer (plusieurs médecins trouvés)
																		</div>
																	</>
																)}
															{eprescriptionAgence &&
																eprescriptionAgence.prescriber &&
																eprescriptionAgence.prescriber.code &&
																!foundDoctor &&
																selectedDoctorList.length === 0 && (
																	<>
																		{eprescriptionAgence.document && <DocumentAgenceDisplay docs={[eprescriptionAgence.document]} />}
																		{`prescrite par ${eprescriptionAgence.prescriber.last_name?.toUpperCase()} ${
																			eprescriptionAgence.prescriber.first_name
																		}`}
																		<div>
																			<Icon name="warning" color="red" />
																			Médecin non connu de MyLab (à créer)
																		</div>
																	</>
																)}
															{eprescription &&
																`Ordonnance ${eprescription.medical_staff_data?.title} ${eprescription.medical_staff_data?.last_name} ${eprescription.medical_staff_data?.first_name}`}
															{preregister && preregister.files && preregister.files.length > 0 && "Ordonnance(s)"}

															{preregister && preregister.files && preregister.files.length > 0 && (
																<div>
																	<OrdonnancesFilesDisplay files={preregister.files} />
																</div>
															)}
															{data.folder?.prescriptions?.length > 0 && data.folder.prescriptions[0].scans?.length > 0 && (
																<div>
																	{" "}
																	<PreregisterScanDisplay scans={data.folder.prescriptions[0].scans} />
																</div>
															)}
														</Segment>
													</Segment.Group>
													<Segment.Group horizontal raised piled>
														{eprescriptionAgence && (
															<Segment basic style={{ minHeight: "100px" }}>
																<div
																	style={{
																		width: "100%",
																	}}
																>
																	<div
																		style={{
																			...styles.titleInfo,
																			width: "100%",
																		}}
																	>
																		<Icon name="info" /> Informations complémentaires reçues via la e-prescription
																	</div>
																	{eprescriptionAgence && eprescriptionAgence.lab_instructions && (
																		<div>
																			<b>Instructions pour le laboratoire :</b> {eprescriptionAgence.lab_instructions}
																		</div>
																	)}
																	{eprescriptionAgence && eprescriptionAgence.patient_instructions && (
																		<div>
																			<b>Instructions pour le patient :</b> {eprescriptionAgence.patient_instructions}
																		</div>
																	)}
																	{eprescriptionAgence && (
																		<div>
																			<b>Copie au patient :</b> {eprescriptionAgence.copy_to_patient ? "Oui" : "Non"}
																		</div>
																	)}
																	{eprescriptionAgence && eprescriptionAgence.contact_point && (
																		<div>
																			<b>Point de contact :</b> {JSON.stringify(eprescriptionAgence.contact_point)}
																		</div>
																	)}

																	{eprescriptionAgence && eprescriptionAgence.copies?.length > 0 && (
																		<div>
																			<b>Copies à :</b>{" "}
																			{eprescriptionAgence.copies.map((c) => `${c.first_name} ${c.last_name} (${c.email})`).join(", ")}
																		</div>
																	)}
																</div>
															</Segment>
														)}
														<Segment basic style={{ minHeight: "100px" }}>
															<div
																style={{
																	...styles.titleInfo,
																	width: "100%",
																	display: "flex",
																	justifyContent: "space-between",
																	alignItems: "flex-end",
																}}
															>
																<div>
																	<Icon name="edit" /> Saisie du dossier {"    "}
																	{data.folder && data.folder.code && `(${data.folder.code})`}
																</div>
																{preregister && (
																	<div>
																		<CommentsToDisplay comments={data.folder?.folderHelp?.comments ?? []} />
																		<Button
																			size="small"
																			circular
																			onClick={(e) => {
																				if (e !== undefined) e.preventDefault();
																				refreshPreregisterFolder(preregister.qr_code);
																			}}
																			icon="refresh"
																		/>
																	</div>
																)}
															</div>
															<div>
																{eprescriptionAgence && analysesToDispenseEPN().filter((a) => a.toDispense).length === 0 && (
																	<div>Aucune analyse à dispenser</div>
																)}
																{eprescriptionAgence && analysesToDispenseEPN().filter((a) => a.toDispense).length > 0 && (
																	<>
																		{eprescriptionAgence &&
																			eprescriptionAgence.analyses.some(
																				(a) => a.bionext.length !== 1 && analysesToDispenseEPN().some((d) => d.code === a.code && d.toDispense)
																			) && (
																				<>
																					{analysesToDispenseEPN().filter((a) => a.toDispense).length !== analysesToDispenseEPN().length && (
																						<div> Il reste {analysesToDispenseEPN().filter((a) => a.toDispense).length} analyse.s à dispenser </div>
																					)}
																					<div>
																						{
																							eprescriptionAgence.analyses.filter(
																								(a) =>
																									a.bionext.length === 1 && analysesToDispenseEPN().some((d) => d.code === a.code && d.toDispense)
																							).length
																						}{" "}
																						analyse.s saisie.s automatiquement
																					</div>
																					<div>
																						{
																							eprescriptionAgence.analyses.filter(
																								(a) =>
																									a.bionext.length !== 1 && analysesToDispenseEPN().some((d) => d.code === a.code && d.toDispense)
																							).length
																						}{" "}
																						analyse.s nécessite.nt une saisie manuelle
																					</div>
																					<div>
																						<Icon name="warning" color="red" /> A envoyer au télésecrétariat
																					</div>
																				</>
																			)}
																		{eprescriptionAgence &&
																			!eprescriptionAgence.analyses.some(
																				(a) => a.bionext.length !== 1 && analysesToDispenseEPN().some((d) => d.code === a.code && d.toDispense)
																			) && (
																				<>
																					<div>
																						{
																							eprescriptionAgence.analyses.filter(
																								(a) =>
																									a.bionext.length === 1 && analysesToDispenseEPN().some((d) => d.code === a.code && d.toDispense)
																							).length
																						}{" "}
																						analyse.s saisie.s automatiquement
																					</div>
																				</>
																			)}
																	</>
																)}

																{eprescription && "Automatique"}
																{eprescription && eprescription.otherDispenses && eprescription.otherDispenses.length > 0 && (
																	<Segment
																		warning
																		icon="info"
																		header={`Cette prescription a déjà été ${
																			analysesToDispenseMyLab(eprescription).length > 0 ? "partiellement" : "complètement"
																		} dispensée dans Nurse.`}
																		content={
																			<>
																				{eprescription.otherDispenses.map((d) => (
																					<div>
																						Dossier {d.folder.code} - <b>Analyses dispensées :</b>{" "}
																						{d.analyses.map((a) => a.properties.code).join(", ")}
																					</div>
																				))}

																				{analysesToDispenseMyLab(eprescription).length > 0 && (
																					<div>
																						<b>Reste à dispenser :</b>{" "}
																						{analysesToDispenseMyLab(eprescription)
																							.map((a) => a.title)
																							.join(", ")}
																						<div>
																							<Field
																								customlabel="N'ajouter que les analyses restantes à dispenser dans le dossier."
																								component={Checkbox}
																								label="onlyNotDispensed"
																								name="onlyNotDispensed"
																								id="onlyNotDispensed"
																							/>
																						</div>
																					</div>
																				)}
																				{analysesToDispenseMyLab(eprescription).length === 0 && (
																					<div>
																						<b>Aucune analyse n'est plus à dispenser</b>
																						<br />
																						<div style={{ margin: isMobile() ? "35px 0" : "0px" }}>
																							<Field
																								customlabel="J'ai bien pris connaissance que toutes les analyses ont déjà été dispensées mais je veux tout de même créer un dossier avec les analyses pour cette e-prescription."
																								component={Checkbox}
																								label="createAlreadyDispensed"
																								name="createAlreadyDispensed"
																								id="createAlreadyDispensed"
																							/>
																						</div>
																					</div>
																				)}
																			</>
																		}
																	></Segment>
																)}
																{data.folder &&
																	!data.folder.folderHelp &&
																	(!preregister || !preregister.files || preregister.files.length === 0) &&
																	"Automatique"}
																{data.folder &&
																	!data.folder.folderHelp &&
																	preregister &&
																	preregister.files &&
																	preregister.files.length > 0 &&
																	"A saisir"}
																{data.folder && data.folder.folderHelp && getTvSecInfo()}
															</div>
														</Segment>
													</Segment.Group>
												</>
											)}
											{!isPatientMyLab && step === 1 && (
												<>
													<Segment>
														<div style={{ display: "flex", justifyContent: "center", marginBottom: "7px" }}>
															<Header as="h4" icon="list" content="Données du formulaire patient" style={{ padding: "auto" }} />
														</div>
														<div>{patientData(data.patient, "form")}</div>
													</Segment>
													<Segment>
														<div>
															Rechercher si ce patient est déjà connu du système sur base du numéro de matricule du patient ou de ses données
															personnelles.
														</div>
														<div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end" }}>
															<div style={{ flex: 1, maxWidth: "150px" }}>
																<Field
																	type="text"
																	name="matricule"
																	placeholder=""
																	component={CustomInputTextComponent}
																	disabled={false}
																	errors={errors}
																/>
															</div>
															<Popup
																content="Cette recherche interroge MyLab"
																position="top center"
																trigger={
																	<Button
																		color="green"
																		style={{ marginBottom: "1px", marginLeft: "5px" }}
																		type="button"
																		disabled={!values.matricule || values.matricule.toString().length < 3}
																		onClick={(e) => {
																			if (e !== undefined) e.preventDefault();
																			setFieldValue("larger", false);
																			searchByMatricule(values.matricule, 1);
																		}}
																	>
																		<Icon name="search" /> Rechercher
																	</Button>
																}
															/>
														</div>
														{mpi && (
															<Message info>
																<Message.Header>
																	<div style={{ display: "flex", justifyContent: "center", marginBottom: "7px" }}>
																		<Header as="h4" icon="list" content="Données de l'annuaire national des patients" style={{ padding: "auto" }} />
																	</div>
																</Message.Header>
																{patientData(mpi, "mpi")}
															</Message>
														)}

														{dsp && (
															<Message info>
																<Message.Header>
																	{" "}
																	<div style={{ display: "flex", justifyContent: "center", marginBottom: "7px" }}>
																		<Header as="h4" icon="list" content="Données DSP" style={{ padding: "auto" }} />
																	</div>
																</Message.Header>
																{patientData(dsp, "dsp")}
															</Message>
														)}
														{mylabListLarger && (
															<Grid style={{ margin: 0 }}>
																<Grid.Row style={{ ...styles.roundHeaderContainer, height: 40, backgroundColor: "red" }}>
																	<Grid.Column
																		style={{ ...styles.columnFlex, justifyContent: "space-between" }}
																		mobile={16}
																		tablet={16}
																		computer={16}
																	>
																		<div style={{ ...styles.columnFlex, color: "#fff", fontWeight: 600 }}>
																			<Icon name="user x" size="large" style={{ ...styles.icon, marginRight: "10px" }} />{" "}
																			<span>
																				Aucun patient trouvé dans MyLab <span style={{ textTransform: "uppercase" }}>avec ce matricule.</span>{" "}
																			</span>
																		</div>
																	</Grid.Column>
																</Grid.Row>
															</Grid>
														)}
													</Segment>

													{mylabList && (
														<Grid style={{ margin: 0, maxHeight: "64vh", overflow: "auto" }}>
															<Grid.Row
																style={{ ...styles.roundHeaderContainer, height: 40, backgroundColor: mylabListLarger ? "orange" : "#43b39e" }}
															>
																<Grid.Column
																	style={{ ...styles.columnFlex, justifyContent: "space-between", padding: "0 0 0 14px" }}
																	mobile={16}
																	tablet={16}
																	computer={16}
																>
																	<div style={{ ...styles.columnFlex, color: "#fff", fontWeight: 600, alignItems: "baseline" }}>
																		<>
																			{mylabList.length > 0 && mylabPagination && Math.ceil(mylabPagination.total / 20) > 1 && (
																				<Icon name="warning sign" style={styles.icon} />
																			)}
																			{mylabList.length > 0 && mylabPagination && Math.ceil(mylabPagination.total / 20) < 2 && (
																				<Icon name="users" size="large" style={styles.icon} />
																			)}
																			{mylabList.length > 0 && mylabPagination && (
																				<>
																					<span>
																						{mylabPagination.total} patient
																						{mylabPagination.total > 1 ? "s" : ""} trouvé
																						{mylabPagination.total > 1 ? "s" : ""} dans MyLab
																						{mylabListLarger ? (
																							<span style={{ textTransform: "uppercase" }}>
																								{" "}
																								avec la même date de naissance et un matricule incomplet
																							</span>
																						) : (
																							""
																						)}
																						.
																					</span>
																				</>
																			)}
																			{mylabPagination && Math.ceil(mylabPagination.total / 20) > 1 && (
																				<span style={{ paddingLeft: "5px" }}>Veuillez affiner votre recherche.</span>
																			)}
																			{mylabList.length === 0 && (
																				<>
																					<Icon name="user x" size="large" style={{ ...styles.icon, marginRight: "10px" }} />
																					<span>Aucun patient trouvé dans MyLab</span>
																				</>
																			)}
																		</>
																	</div>
																	{mylabPagination && Math.ceil(mylabPagination.total / 20) > 1 && (
																		<div
																			style={{
																				...styles.columnFlex,
																				color: "#fff",
																				fontWeight: 600,
																			}}
																		>
																			<span>
																				Page {page}/{Math.ceil(mylabPagination.total / 20)}{" "}
																			</span>
																		</div>
																	)}
																</Grid.Column>
															</Grid.Row>
															{mylabList.map((l, index) => (
																<React.Fragment key={"fragpatientmylab" + index}>
																	<Grid.Row
																		key={"patientmylab" + index}
																		style={mylab && mylab.id === l.id ? styles.patientListSelected : styles.patientList}
																	>
																		{mylab && mylab.id === l.id && (
																			<>
																				<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "flex-start" }}>
																					<Label as="span" color="teal" ribbon>
																						Patient sélectionné
																					</Label>
																					<MainButton
																						text="Ne pas utiliser ce patient"
																						style={{ backgroundColor: "darkred" }}
																						onClick={(e) => {
																							if (e !== undefined) {
																								e.preventDefault();
																								e.stopPropagation();
																							}
																							deselectPatientMyLab();
																						}}
																					/>
																				</div>

																				<Grid.Column mobile={16} tablet={16} computer={16} style={{ textAlign: "right" }}></Grid.Column>

																				<Grid.Column mobile={16} tablet={16} computer={11}>
																					<div>
																						<span style={{ color: "black", paddingLeft: "0.5em" }}>
																							{displayGender(l, generalParameters.data)} {displayName(l)}
																						</span>
																						<span style={{ padding: "0 2em" }}>{moment().diff(l.birth_date, "years")} ans </span>
																						{l.active && (
																							<span style={{ fontSize: "0.8em" }}>
																								<Icon name="heart" /> MyLab actif
																							</span>
																						)}
																					</div>
																				</Grid.Column>
																			</>
																		)}
																		{(!mylab || mylab.id !== l.id) && (
																			<>
																				<Grid.Column mobile={16} tablet={5} computer={5}>
																					<div>
																						<b>
																							{displayGender(l, generalParameters.data)} {displayName(l)}
																						</b>
																						<br />
																						<span style={{ fontSize: "0.8em", fontStyle: "italic" }}>{moment().diff(l.birth_date, "years")} ans</span>
																					</div>
																				</Grid.Column>

																				<Grid.Column mobile={16} tablet={3} computer={3} style={{}}>
																					<b style={{ fontSize: "0.8em" }}>
																						{" "}
																						{l.gender === "f" ? "Née" : "Né"} le{" "}
																						{moment(l.birth_date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)}
																					</b>
																				</Grid.Column>

																				<Grid.Column mobile={16} tablet={3} computer={3} style={{}}>
																					<div>
																						<b style={{ fontSize: "0.8em" }}>N° {l.cns}</b>
																					</div>
																					{l.active && (
																						<span style={{ fontSize: "0.8em" }}>
																							<Icon name="heart" /> MyLab actif
																						</span>
																					)}
																				</Grid.Column>

																				<Grid.Column mobile={16} tablet={5} computer={5} style={{ textAlign: "right" }}>
																					<MainButton
																						text="Sélectionner ce patient"
																						onClick={(e) => {
																							if (e !== undefined) {
																								e.preventDefault();
																								e.stopPropagation();
																							}
																							selectPatientMyLab(l);
																						}}
																					/>
																					{mylab && mylab.id === l.id && (
																						<div>
																							<span style={{ color: "darkred", textAlign: "center" }}>Patient sélectionné</span>
																							<MainButton
																								text="Ne pas utiliser ce patient"
																								style={{ backgroundColor: "darkred" }}
																								onClick={(e) => {
																									if (e !== undefined) {
																										e.preventDefault();
																										e.stopPropagation();
																									}
																									deselectPatientMyLab();
																								}}
																							/>
																						</div>
																					)}
																				</Grid.Column>
																			</>
																		)}
																	</Grid.Row>

																	{mylab && mylab.id === l.id && (
																		<Grid.Row key={"patientmylabSelected" + index} style={styles.patientListSelectedData}>
																			{patientData(mylab, "mylab")}
																		</Grid.Row>
																	)}
																</React.Fragment>
															))}

															{mylabPagination && Math.ceil(mylabPagination.total / 20) > 1 && (
																<Grid.Row>
																	<CustomPagination
																		activePage={page}
																		totalPages={Math.ceil(mylabPagination.total / 20)}
																		onPageChange={(e, { activePage }) => {
																			searchByMatricule(values.matricule, activePage);
																		}}
																	/>
																</Grid.Row>
															)}
														</Grid>
													)}
												</>
											)}
											{step === 2 && isEPrescriptionAgence && (
												<>
													<Segment>
														<div style={{ display: "flex", justifyContent: "center", marginBottom: "7px" }}>
															<Header as="h4" icon="list" content="Données du médecin" style={{ padding: "auto" }} />
														</div>
														<div>{doctorData(eprescriptionAgence.prescriber)}</div>
													</Segment>
													<Segment>
														<div>Rechercher si ce médecin est déjà connu du système sur base de son code CNS.</div>
														<div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end" }}>
															<div style={{ flex: 1, maxWidth: "150px" }}>
																<Field
																	type="text"
																	name="doctorCode"
																	placeholder=""
																	component={CustomInputTextComponent}
																	disabled={false}
																	errors={errors}
																/>
															</div>
															<Popup
																content="Cette recherche interroge MyLab"
																position="top center"
																trigger={
																	<Button
																		color="green"
																		style={{ marginBottom: "1px", marginLeft: "5px" }}
																		type="button"
																		disabled={!values.doctorCode || values.doctorCode.toString().length < 3}
																		onClick={(e) => {
																			if (e !== undefined) e.preventDefault();
																			searchDoctor(values.doctorCode);
																		}}
																	>
																		<Icon name="search" /> Rechercher
																	</Button>
																}
															/>
														</div>
													</Segment>
													<Segment>
														{selectedDoctorList && (
															<Grid style={{ margin: 0, maxHeight: "64vh", overflow: "auto" }}>
																<Grid.Row
																	style={{ ...styles.roundHeaderContainer, height: 40, backgroundColor: mylabListLarger ? "orange" : "#43b39e" }}
																>
																	<Grid.Column
																		style={{ ...styles.columnFlex, justifyContent: "space-between", padding: "0 0 0 14px" }}
																		mobile={16}
																		tablet={16}
																		computer={16}
																	>
																		<div style={{ ...styles.columnFlex, color: "#fff", fontWeight: 600, alignItems: "baseline" }}>
																			<>
																				<span>
																					{selectedDoctorList.length > 0 ? selectedDoctorList.length : "Aucun"} médecin
																					{selectedDoctorList.length > 1 ? "s" : ""} trouvé
																					{selectedDoctorList.length > 1 ? "s" : ""} dans MyLab.
																				</span>
																			</>
																		</div>
																	</Grid.Column>
																</Grid.Row>
																{selectedDoctorList.map((d, index) => (
																	<Grid.Row
																		key={`doctor-${index}`}
																		style={selectedDoctor && selectedDoctor.id === d.id ? styles.doctorListSelected : styles.patientList}
																	>
																		{selectedDoctor && selectedDoctor.id === d.id && (
																			<>
																				<div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "flex-start" }}>
																					<Label as="span" color="teal" ribbon>
																						Médecin sélectionné
																					</Label>
																					<MainButton
																						text="Ne pas utiliser ce médecin"
																						style={{ backgroundColor: "darkred" }}
																						onClick={(e) => {
																							if (e !== undefined) {
																								e.preventDefault();
																								e.stopPropagation();
																							}
																							setSelectedDoctor(null);
																						}}
																					/>
																				</div>

																				<Grid.Column mobile={16} tablet={16} computer={16} style={{ textAlign: "right" }}></Grid.Column>
																			</>
																		)}

																		<Grid.Column mobile={16} tablet={5} computer={2}>
																			{d.code}
																		</Grid.Column>
																		<Grid.Column mobile={16} tablet={5} computer={4}>
																			{d.last_name} {d.first_name}
																		</Grid.Column>
																		<Grid.Column mobile={16} tablet={5} computer={2}>
																			{d.speciality}
																		</Grid.Column>
																		<Grid.Column
																			mobile={16}
																			tablet={5}
																			computer={4}
																		>{`${d.address.street} ${d.address.postal_code} ${d.address.city}`}</Grid.Column>
																		<Grid.Column mobile={16} tablet={5} computer={4} style={{ textAlign: "right" }}>
																			{(!selectedDoctor || selectedDoctor.id !== d.id) && (
																				<MainButton
																					text="Sélectionner ce médecin"
																					onClick={(e) => {
																						if (e !== undefined) {
																							e.preventDefault();
																							e.stopPropagation();
																						}
																						setSelectedDoctor(d);
																					}}
																				/>
																			)}
																		</Grid.Column>
																	</Grid.Row>
																))}
															</Grid>
														)}
													</Segment>
												</>
											)}
											{step === 3 && (
												<>
													{!isPatientMyLab && (mylab || mpi || dsp) && (
														<Segment>
															<div style={{ margin: "15px 0" }}>
																<div style={{ margin: "20px 0 40px" }}>
																	{patientDataUpdated(data.patient, mylab, mpi, dsp, defineFields(data.patient, mylab, mpi, dsp), values)}
																</div>
																{!!mylab &&
																	getModifiedFields(data.patient, mylab, mpi, dsp, !!mylab).filter((e) =>
																		Object.entries(values).some((v) => e.field === v[0] && v[1] !== "mylab")
																	).length > 0 && (
																		<Message color="red" style={{ fontSize: "0.9em", textAlign: "center" }}>
																			<Message.Header>! Modification de données sensibles du patient !</Message.Header>
																			<div style={{ fontWeight: "bold", color: "black" }}>Vous vous apprêtez à modifier ces données :</div>
																			<span style={{ fontSize: "1.4em", backgroundColor: "yellow", color: "red" }}>
																				{getModifiedFields(data.patient, mylab, mpi, dsp, !!mylab)
																					.filter((e) => Object.entries(values).some((v) => e.field === v[0] && v[1] !== "mylab"))
																					.map((f) => f.label)
																					.join(", ")}
																			</span>
																			<div
																				style={{ textTransform: "uppercase", fontWeight: "bold", margin: "25px 0 0", textDecoration: "underline" }}
																			>
																				Etes-vous sûr de vouloir modifier ce patient ?{" "}
																			</div>
																			<div>Cela aura un impact sur tous les dossiers de ce patient. </div>
																			<div style={{ fontWeight: "bold", margin: "25px 0 0", textDecoration: "underline" }}>
																				<span style={{ textTransform: "uppercase" }}>
																					Le patient MyLab sélectionné n’est pas le patient à prélever ?
																				</span>
																			</div>
																			<div>
																				Retournez à l'étape précédente et utilisez la recherche pour trouver le bon patient ou cliquez sur 'Ne pas
																				utiliser ce patient' pour le désélectionner et en créer un nouveau.
																			</div>
																		</Message>
																	)}
															</div>
														</Segment>
													)}
													{!isPatientMyLab && !mylab && !mpi && !dsp && (
														<Message info>
															<Message.Header>Données du nouveau patient à créer</Message.Header>
															{patientData(data.patient, "form")}
														</Message>
													)}
													{isEPrescriptionAgence && selectedDoctor && (
														<Message info>
															<Message.Header>Données du médecin sélectionné</Message.Header>
															{doctorDataUpdated(eprescriptionAgence.prescriber, selectedDoctor)}
														</Message>
													)}
													{isEPrescriptionAgence && !selectedDoctor && (
														<Message info>
															<Message.Header>Nouveau médecin à créer dans MyLab</Message.Header>
															{doctorData(eprescriptionAgence.prescriber)}
														</Message>
													)}
													{isEPrescriptionAgence && eprescriptionAgence.analyses && (
														<Message info>
															<Message.Header>Correspondance des analyses</Message.Header>
															{analysesData(eprescriptionAgence.analyses)}
														</Message>
													)}
												</>
											)}
										</Segment>
									)}
								</Form>
							)}
						</Modal.Content>

						<Modal.Actions>
							<Button
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									closeModal();
								}}
							>
								Annuler
							</Button>
							{!isAffectedToTVSec && isWaitingToTVSec && (
								<Button
									color="red"
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										cancelFolderHelp(
											data.folder.id,
											"Prise en charge par la préleveuse",
											preregister ? preregister.qr_code : eprescription ? eprescription.qr_code : ""
										);
									}}
								>
									Annuler la demande de télésecrétariat
								</Button>
							)}
							{(isAffectedToTVSec || isWaitingToTVSec) && (
								<Button
									primary
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										if (values.toBeNotify) notifyMeForPreregister(data.folder.folderHelp.id);
										closeModal();
									}}
								>
									Fermer
								</Button>
							)}

							{!isAffectedToTVSec && (
								<>
									{!isWaitingToTVSec && (
										<>
											{isPatientMyLab && !isEPrescriptionMyLab && (
												<Button
													primary
													onClick={(e) => {
														if (e !== undefined) e.preventDefault();
														handleOpenFolderClick(values, false);
													}}
												>
													Ouvrir le dossier
												</Button>
											)}
											{isPatientMyLab && isEPrescriptionMyLab && analysesToDispenseMyLab(eprescription).length > 0 && (
												<Button
													primary
													onClick={(e) => {
														if (e !== undefined) e.preventDefault();

														handleUsePatient(values);
													}}
												>
													Ouvrir le dossier
												</Button>
											)}
											{values.createAlreadyDispensed &&
												isPatientMyLab &&
												isEPrescriptionMyLab &&
												analysesToDispenseMyLab(eprescription).length === 0 && (
													<Button
														primary
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();

															handleUsePatient(values);
														}}
													>
														Ouvrir le dossier
													</Button>
												)}
											{((!isPatientMyLab && !eprescriptionAgence) ||
												(eprescriptionAgence && analysesToDispenseEPN().filter((a) => a.toDispense).length !== 0)) && (
												<>
													{step > 0 && (
														<Button
															color="red"
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																setStep(step === 3 && !eprescriptionAgence ? step - 2 : step - 1);
															}}
														>
															Précédent
														</Button>
													)}
													{step === 0 && (
														<Button
															primary
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																if (data?.patient?.matricule || data?.patient?.cns)
																	searchByMatricule(data?.patient?.matricule || data?.patient?.cns, 1);
																setStep(1);
															}}
														>
															Suivant
														</Button>
													)}

													{mylab && step === 1 && (
														<Button
															primary
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																values.useMylab = true;
																setStep(!eprescriptionAgence || foundDoctor ? 3 : 2);
															}}
														>
															Utiliser ce patient
														</Button>
													)}
													{!mylab && step === 1 && (
														<Button
															primary
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																setStep(!eprescriptionAgence || foundDoctor ? 3 : 2);
															}}
														>
															Créer un nouveau patient
														</Button>
													)}
													{step === 2 && (
														<Button
															primary
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																setStep(3);
															}}
														>
															{selectedDoctor ? "Utiliser ce médecin" : "Créer un nouveau médecin"}
														</Button>
													)}
													{step === 3 && (
														<Button
															primary
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																mylab ? handleUsePatient(values) : handleCreatePatient(values);
															}}
														>
															{isEPrescriptionAgence &&
															eprescriptionAgence.analyses.some(
																(a) => a.bionext.length !== 1 && analysesToDispenseEPN().some((d) => d.code === a.code && d.toDispense)
															)
																? "Télésecrétariat"
																: mylab
																? "Utiliser ce patient et ouvrir le dossier"
																: "Créer un nouveau patient et ouvrir le dossier"}
														</Button>
													)}
												</>
											)}
										</>
									)}
								</>
							)}
						</Modal.Actions>
					</>
				)}
			</Formik>
		</Modal>
	);
};
const CommentsToDisplay = ({ comments }) => {
	const [openModal, setOpenModal] = useState(false);
	return (
		<>
			{comments && comments.length > 0 && (
				<Button
					size="small"
					circular
					onClick={(e) => {
						if (e !== undefined) e.preventDefault();
						setOpenModal(true);
					}}
					icon="comment"
				/>
			)}
			<Modal open={openModal} closeOnEscape closeOnDimmerClick onClose={() => setOpenModal(false)}>
				<Modal.Header>Commentaires enregistrés</Modal.Header>
				<Modal.Content style={{ maxHeight: "75vh" }}>
					{comments.map((c) => (
						<p key={`comment-${c.id}`}>
							{moment(c.created_at).format("DD MMM")} à {moment(c.created_at).format("HH:mm")} : {c.comment}
						</p>
					))}
				</Modal.Content>
			</Modal>
		</>
	);
};
const OrdonnancesFilesDisplay = ({ files }) => {
	const b64toBlob = (b64Data, contentType) => {
		var byteCharacters = atob(b64Data);

		var byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += 512) {
			var slice = byteCharacters.slice(offset, offset + 512),
				byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}
			var byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}

		var blob = new Blob(byteArrays, { type: contentType });
		return blob;
	};
	const [docToDisplay, setDocToDisplay] = useState(null);
	const [openModal, setOpenModal] = useState(false);
	const getType = (filename) => {
		if (filename.substring(filename.length - 3) === "pdf") return "application/pdf";
		if (filename.substring(filename.length - 3) === "jpg") return "image/jpg";
		if (filename.substring(filename.length - 3) === "png") return "image/png";
		if (filename.substring(filename.length - 4) === "jpeg") return "image/jpeg";
	};

	return (
		<>
			<List>
				{files.map((f, idx) => (
					<List.Item key={`file-${idx}`}>
						<List.Icon
							name={f.name.substring(f.name.length - 3) === "pdf" ? "file pdf outline" : "file image outline"}
							style={{ paddingRight: "0.2em" }}
						/>
						<List.Content>
							<List.Header
								as="a"
								onClick={() => {
									setDocToDisplay(f);
									setOpenModal(true);
								}}
							>
								Ordonnance {idx + 1} au format {f.name.substring(f.name.length - 4)}
							</List.Header>
						</List.Content>
					</List.Item>
				))}
			</List>
			<Modal open={openModal} size="large" closeOnEscape closeOnDimmerClick onClose={() => setOpenModal(false)}>
				<Modal.Header>Ordonnance téléchargée via Safeplace</Modal.Header>
				<Modal.Content style={{ maxHeight: "75vh" }}>
					{docToDisplay &&
						docToDisplay.name &&
						(docToDisplay.name.substring(docToDisplay.name.length - 3) === "png" ||
							docToDisplay.name.substring(docToDisplay.name.length - 3) === "jpg" ||
							docToDisplay.name.substring(docToDisplay.name.length - 4) === "jpeg") && (
							<div>
								<MapInteractionCSS minScale={0.5} maxScale={3}>
									<Image
										src={`data:${getType(docToDisplay.name)};charset=utf-8;base64,${docToDisplay.data}`}
										onContextMenu={(e) => e.preventDefault()}
										style={{ width: "auto", height: "73vh" }}
									/>
								</MapInteractionCSS>
							</div>
						)}
					{docToDisplay && docToDisplay.name && docToDisplay.name.substring(docToDisplay.name.length - 3) === "pdf" && (
						<iframe
							id="fraDisabled"
							//Prevent download
							src={URL.createObjectURL(b64toBlob(docToDisplay.data, "application/pdf")) + "#toolbar=0"}
							// src={`data:${files[fileIndex].type};base64,${files[fileIndex].base64}`}
							title={"Ordonnance envoyée"}
							name={docToDisplay.name}
							style={{ width: "100%", height: "73vh" }}
						></iframe>
					)}
				</Modal.Content>
				<Modal.Actions>
					<Button content="Fermer" onClick={() => setOpenModal(false)} />
				</Modal.Actions>
			</Modal>
		</>
	);
};

const PreregisterScanDisplay = ({ scans }) => {
	const b64toBlob = (b64Data, contentType) => {
		var byteCharacters = atob(b64Data);

		var byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += 512) {
			var slice = byteCharacters.slice(offset, offset + 512),
				byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}
			var byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}

		var blob = new Blob(byteArrays, { type: contentType });
		return blob;
	};
	const [docToDisplay, setDocToDisplay] = useState(null);
	const [openModal, setOpenModal] = useState(false);
	const getType = (filename) => {
		if (filename.substring(filename.length - 3) === "pdf") return "application/pdf";
		if (filename.substring(filename.length - 3) === "jpg") return "image/jpg";
		if (filename.substring(filename.length - 3) === "png") return "image/png";
		if (filename.substring(filename.length - 4) === "jpeg") return "image/jpeg";
	};

	return (
		<>
			<List>
				{scans.map((s, idx) => (
					<List.Item key={`file-${idx}`}>
						<List.Icon
							name={s.filename.substring(s.filename.length - 3) === "pdf" ? "file pdf outline" : "file image outline"}
							style={{ paddingRight: "0.2em" }}
						/>
						<List.Content>
							<List.Header
								as="a"
								onClick={() => {
									setDocToDisplay(s);
									setOpenModal(true);
								}}
							>
								Ordonnance {idx + 1} au format {s.filename.substring(s.filename.length - 4)}
							</List.Header>
						</List.Content>
					</List.Item>
				))}
			</List>
			<Modal open={openModal} size="large" closeOnEscape closeOnDimmerClick onClose={() => setOpenModal(false)}>
				<Modal.Header>Ordonnance téléchargée via une pré-inscription</Modal.Header>
				<Modal.Content style={{ maxHeight: "75vh" }}>
					{docToDisplay &&
						docToDisplay.filename &&
						(docToDisplay.filename.substring(docToDisplay.filename.length - 3) === "png" ||
							docToDisplay.filename.substring(docToDisplay.filename.length - 3) === "jpg" ||
							docToDisplay.filename.substring(docToDisplay.filename.length - 4) === "jpeg") && (
							<div>
								<MapInteractionCSS minScale={0.5} maxScale={3}>
									<Image
										src={`data:${getType(docToDisplay.filename)};charset=utf-8;base64,${docToDisplay.base64}`}
										onContextMenu={(e) => e.preventDefault()}
										style={{ width: "auto", height: "73vh" }}
									/>
								</MapInteractionCSS>
							</div>
						)}
					{docToDisplay && docToDisplay.filename && docToDisplay.filename.substring(docToDisplay.filename.length - 3) === "pdf" && (
						<iframe
							id="fraDisabled"
							//Prevent download
							src={URL.createObjectURL(b64toBlob(docToDisplay.base64, "application/pdf")) + "#toolbar=0"}
							// src={`data:${files[fileIndex].type};base64,${files[fileIndex].base64}`}
							title={"Ordonnance envoyée"}
							name={docToDisplay.filename}
							style={{ width: "100%", height: "73vh" }}
						></iframe>
					)}
				</Modal.Content>
				<Modal.Actions>
					<Button content="Fermer" onClick={() => setOpenModal(false)} />
				</Modal.Actions>
			</Modal>
		</>
	);
};

const DocumentAgenceDisplay = ({ docs }) => {
	const b64toBlob = (b64Data, contentType) => {
		var byteCharacters = atob(b64Data);

		var byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += 512) {
			var slice = byteCharacters.slice(offset, offset + 512),
				byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}
			var byteArray = new Uint8Array(byteNumbers);

			byteArrays.push(byteArray);
		}

		var blob = new Blob(byteArrays, { type: contentType });
		return blob;
	};
	const [docToDisplay, setDocToDisplay] = useState(null);
	const [openModal, setOpenModal] = useState(false);
	return (
		<>
			<List>
				{docs.map((doc, idx) => (
					<List.Item key={`file-${idx}`}>
						<List.Icon name={doc.type === "application/pdf" ? "file pdf outline" : "file image outline"} style={{ paddingRight: "0.2em" }} />
						<List.Content>
							<List.Header
								as="a"
								onClick={() => {
									setDocToDisplay(doc);
									setOpenModal(true);
								}}
							>
								Ordonnance {idx + 1} au format {doc.type === "application/pdf" ? "pdf" : "image"}
							</List.Header>
						</List.Content>
					</List.Item>
				))}
			</List>
			<Modal open={openModal} size="large" closeOnEscape closeOnDimmerClick onClose={() => setOpenModal(false)}>
				<Modal.Header>Ordonnance e-prescription nationale</Modal.Header>
				<Modal.Content style={{ maxHeight: "75vh" }}>
					{docToDisplay && docToDisplay.type !== "application/pdf" && (
						<div>
							<MapInteractionCSS minScale={0.5} maxScale={3}>
								<Image
									src={`data:${docToDisplay.type};charset=utf-8;base64,${docToDisplay.data}`}
									onContextMenu={(e) => e.preventDefault()}
									style={{ width: "auto", height: "73vh" }}
								/>
							</MapInteractionCSS>
						</div>
					)}
					{docToDisplay && docToDisplay.type === "application/pdf" && (
						<iframe
							id="fraDisabled"
							//Prevent download
							src={URL.createObjectURL(b64toBlob(docToDisplay.data, "application/pdf")) + "#toolbar=0"}
							title={"E-prescription nationale"}
							name={"Ordonnance"}
							style={{ width: "100%", height: "73vh" }}
						></iframe>
					)}
				</Modal.Content>
				<Modal.Actions>
					<Button content="Fermer" onClick={() => setOpenModal(false)} />
				</Modal.Actions>
			</Modal>
		</>
	);
};

export default PatientMatchingModal;
